import React from 'react'
import ClientSuspense from '@components/ClientSuspense'
import Image from '@components/Image'
import Card from '@components/V3/Card'
import classnames from '@helpers/misc/classnames'
import useInitialData from '@page-components/Layout/useInitialData'
import Link from 'next/link'

import Skeleton from './Skeleton'

export function Logo({center = false, noLink = false}: {center?: boolean; noLink?: boolean}) {
  const initialData = useInitialData()
  const {website} = initialData

  if (!website) return null

  const logo = website.logo
  if (!logo) return null

  return <>
    <Card
      className={classnames({
        'w-full max-w-[1024px] flex flex-col justify-center !px-4': true,
        'md:justify-start': !center
      })}
      transparentOnDesktop>
      <div
        className={classnames({
          'relative md:mb-4 rounded-xl py-1 bg-white': true,
          'md:mr-auto': !center,
          'md:mx-auto': center
        })}>
        <div className="mx-auto md:mx-2 my-1 relative h-[100px] w-[150px]">
          <Link href={noLink ? '#' : '/'}>

            <Image
              priority
              src={logo.url}
              alt={website.name || 'Logo'}
              title={website.name || 'logo'}
              objectFit="contain"
              layout="fill"
            />

          </Link>
        </div>
      </div>
    </Card>
  </>;
}

export default function LogoWrapper() {
  return (
    <ClientSuspense fallback={<Skeleton />}>
      <Logo />
    </ClientSuspense>
  )
}
